/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum TxType {
  ADD_LIQUIDITY = 'ADD_LIQUIDITY',
  REMOVE_LIQUIDITY = 'REMOVE_LIQUIDITY',
  CLAIM = 'CLAIM',
  REINVEST = 'REINVEST',
  STAKE = 'STAKE',
  UNSTAKE = 'UNSTAKE',
  MIGRATION = 'MIGRATION',
  SWAP = 'SWAP',
}

export function TxTypeFromJSON(json: any): TxType {
  return TxTypeFromJSONTyped(json, false)
}

export function TxTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TxType {
  return json as TxType
}

export function TxTypeToJSON(value?: TxType | null): any {
  return value as any
}
